<template>
  <div>
  <v-select
      v-if="!inSelectMode"
      v-model="category_select_value"
      :items="category_select"
      filled
      hide-details
      label="Darstellungsart"
      @change="$emit('category-changed', category_select_value)"
  >
    <template v-slot:append-item>
      <v-list-item
          ripple
          @mousedown.prevent
          @click="$emit('create-combo')"
      >
        <v-list-item-action>
          <v-icon :color="'blue'">
            {{ 'mdi-plus' }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Erstellen
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>
    <v-list v-if="category_select_value === 'AUGR'" expand flat :class="{'cadastre-list': true, 'select-mode': inSelectMode}">
      <v-list-group
          v-for="(toplevel, d) in definitions"
          :key="toplevel.id"
          :append-icon="''"
          @click.capture="onItemClicked($event, toplevel.id, d)"
          :class="{'active-background': toplevel.id === currentSelection}"
          :value="toplevel.expanded"
        >
        <template v-slot:activator>
          <v-list-item-title style="margin-left: 6px" :class="{'active-title': toplevel.id === currentSelection}" v-text="toplevel.name"></v-list-item-title>
          <div v-if="toplevel.id === currentSelection && !inSelectMode">
            <v-btn
                icon
                color="success"
                @click.capture.stop="$emit('edit-definition', toplevel.id, d)"
            >
              <v-icon v-text="'mdi-pencil'"></v-icon>
            </v-btn>
          </div>
          <div :class="{'v-list-item__icon': true, 'v-list-group__header__append-icon': true, 'hidden': !toplevel.entries || !toplevel.entries.length}" style="margin-left:0px">
            <v-btn
                icon
            >
              <v-icon v-text="'mdi-chevron-down'"></v-icon>
            </v-btn>
          </div>
        </template>
        <v-list-group
            v-for="(toplevelCadastre, c) in toplevel.entries"
            :key="toplevelCadastre.id"
            sub-group
            :prepend-icon="''"
            @click.capture="onItemClicked($event, toplevelCadastre.id, d, c)"
            :class="{'active-background': toplevelCadastre.id === currentSelection}"
            :value="toplevelCadastre.expanded"
        >
          <template v-slot:activator
          >
            <div :class="{'v-list-item__icon': true, 'v-list-group__header__prepend-icon': true, 'hidden': !toplevelCadastre.definitions || !toplevelCadastre.definitions.length}">
              <v-btn
                  icon small
              >
                <v-icon v-text="'mdi-menu-down'"></v-icon>
              </v-btn>
            </div>
            <v-list-item-title :ref="`${toplevelCadastre.id}`" :class="{'active-title': toplevelCadastre.id === currentSelection}" v-text="toplevelCadastre.name"></v-list-item-title>
          </template>
          <v-list expand flat>
            <v-list-group
                v-for="(subDefinition, sd) in toplevelCadastre.definitions"
                :key="subDefinition.id + '$' + toplevelCadastre.id"
                sub-group
                style="padding-left: 18px"
                :prepend-icon="''"
                @click.c.capture="onItemClicked($event, subDefinition.id+ '$' + toplevelCadastre.id, d, c, sd)"
                :class="{'active-background': subDefinition.id + '$' + toplevelCadastre.id === currentSelection}"
                :value="subDefinition.expanded"
            >
              <template v-slot:activator>
                <div :class="{'v-list-item__icon': true, 'expanded':  true, 'hidden': !subDefinition.entries || !subDefinition.entries.length}" style="margin-left: 0px">
                  <v-btn
                      icon small
                  >
                    <v-icon v-text="'mdi-menu-down'"></v-icon>
                  </v-btn>
                </div>
                <v-list-item-title :class="{'active-title': subDefinition.id + '$' + toplevelCadastre.id === currentSelection}" v-text="subDefinition.name"></v-list-item-title>
                <div v-if="subDefinition.id + '$' + toplevelCadastre.id === currentSelection  && !inSelectMode">
                  <v-btn
                      icon
                      color="success"
                      @click.capture.stop="$emit('edit-definition', subDefinition.id, d, c, sd)"
                  >
                    <v-icon v-text="'mdi-pencil'"></v-icon>
                  </v-btn>
                </div>
                <div v-if="subDefinition.id + '$' + toplevelCadastre.id === currentSelection  && !inSelectMode">
                  <v-btn
                      icon
                      color="success"
                      @click.capture.stop="$emit('add-entry', subDefinition.id, toplevelCadastre.aufisn)"
                  >
                    <v-icon v-text="'mdi-plus'"></v-icon>
                  </v-btn>
                </div>
              </template>
              <v-list-item-group>
                <v-list-item
                    v-for="(subCadastre, sc) in subDefinition.entries"
                    :key="subCadastre.id"
                    :class="{'active-background': subCadastre.id === currentSelection}"
                    @click.stop.prevent.capture="onItemClicked($event, subCadastre.id, d, c, sd, sc)"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-content>
                      <v-list-item-title :ref="`${subCadastre.id}`" :class="{'active-title': subCadastre.id === currentSelection}" v-text="subCadastre.name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list-group>
          </v-list>
        </v-list-group>
      </v-list-group>
    </v-list>
    <v-list v-else expand flat :class="{'cadastre-list': true, 'select-mode': inSelectMode}">
      <v-list-group
          :append-icon="''"
          @click.capture="$emit('add-definition')"
          v-if="category_select_value === 'CADASTRE'"
      >
        <template v-slot:activator>
          <div :class="{'v-list-item__icon': true, 'v-list-group__header__prepend-icon': true}">
            <v-btn
                icon small
            >
              <v-icon v-text="'mdi-plus'" color="success"></v-icon>
            </v-btn>
          </div>
          <v-list-item-title style="margin-left: 6px"  v-text="'Kataster anlegen'"></v-list-item-title>
        </template>
      </v-list-group>
      <v-list-group
          v-for="(toplevel, d) in definitions"
          :key="toplevel.id"
          :append-icon="''"
          @click.capture="onItemClicked($event, toplevel.id, d)"
          :class="{'active-background': toplevel.id === currentSelection}"
          :value="toplevel.expanded"
        >
        <template v-slot:activator>
          <v-list-item-title style="margin-left: 6px" :class="{'active-title': toplevel.id === currentSelection}" v-text="toplevel.name"></v-list-item-title>
          <div v-if="toplevel.id === currentSelection">
            <v-btn
                icon
                color="success"
                @click.capture.stop="$emit('add-entry', toplevel.id)"
            >
              <v-icon v-text="'mdi-plus'"></v-icon>
            </v-btn>
          </div>
          <div v-if="toplevel.id === currentSelection">
            <v-btn
                icon
                color="success"
                @click.capture.stop="$emit('edit-definition', toplevel.id, d)"
            >
              <v-icon v-text="'mdi-pencil'"></v-icon>
            </v-btn>
          </div>
          <div :class="{'v-list-item__icon': true, 'v-list-group__header__append-icon': true, 'hidden': !toplevel.sub_definitions || !toplevel.sub_definitions.length}" style="margin-left:0px">
            <v-btn
                icon
            >
              <v-icon v-text="'mdi-chevron-down'"></v-icon>
            </v-btn>
          </div>
        </template>
        <v-list-group
            v-for="(subDefinition, c) in toplevel.sub_definitions"
            :key="toplevel.id + '$' + subDefinition.id"
            sub-group
            :prepend-icon="''"
            @click.capture="onItemClicked($event, toplevel.id + '$' + subDefinition.id, d, c)"
            :class="{'active-background': toplevel.id + '$' + subDefinition.id === currentSelection}"
            :value="subDefinition.expanded"
        >
          <template v-slot:activator
          >
            <div :class="{'v-list-item__icon': true, 'v-list-group__header__prepend-icon': true, 'hidden': !subDefinition.entries || !subDefinition.entries.length}">
              <v-btn
                  icon small
              >
                <v-icon v-text="'mdi-menu-down'"></v-icon>
              </v-btn>
            </div>
            <v-list-item-title :ref="`${toplevel.id + '$' + subDefinition.id}`" :class="{'active-title': toplevel.id + '$' + subDefinition.id === currentSelection}" v-text="subDefinition.name"></v-list-item-title>
            <div v-if="toplevel.id + '$' + subDefinition.id === currentSelection">
              <v-btn
                  icon
                  color="success"
                  @click.capture.stop="$emit('add-entry', subDefinition.id)"
              >
                <v-icon v-text="'mdi-plus'"></v-icon>
              </v-btn>
            </div>
            <div v-if="toplevel.id + '$' + subDefinition.id === currentSelection">
              <v-btn
                  icon
                  color="success"
                  @click.capture.stop="$emit('edit-definition', toplevel.id + '$' + subDefinition.id, d, c)"
              >
                <v-icon v-text="'mdi-pencil'"></v-icon>
              </v-btn>
            </div>
          </template>
          <v-list expand flat>
            <v-list-group
                v-for="(toplevelCadastre, sd) in subDefinition.entries"
                :key="toplevel.id + '$' + toplevelCadastre.id"
                sub-group
                style="padding-left: 18px"
                :prepend-icon="''"
                @click.c.capture="onItemClicked($event, toplevel.id + '$' + toplevelCadastre.id, d, c, sd)"
                :class="{'active-background': toplevel.id + '$' + toplevelCadastre.id === currentSelection}"
                :value="toplevelCadastre.expanded"
            >
              <template v-slot:activator>
                <div :class="{'v-list-item__icon': true, 'expanded':  true, 'hidden': !toplevelCadastre.sub_cadastres || !toplevelCadastre.sub_cadastres.length}" style="margin-left: 0px">
                  <v-btn
                      icon small
                  >
                    <v-icon v-text="'mdi-menu-down'"></v-icon>
                  </v-btn>
                </div>
                <v-list-item-title :class="{'active-title': toplevel.id + '$' + toplevelCadastre.id === currentSelection}" v-text="toplevelCadastre.name"></v-list-item-title>
              </template>
              <v-list-item-group>
                <v-list-item
                    v-for="(subCadastre, sc) in toplevelCadastre.sub_cadastres"
                    :key="subCadastre.id"
                    :class="{'active-background': subCadastre.id === currentSelection}"
                    @click.stop.prevent.capture="onItemClicked($event, subCadastre.id, d, c, sd, sc)"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-content>
                      <v-list-item-title :ref="`${subCadastre.id}`" :class="{'active-title': subCadastre.id === currentSelection}" v-text="subCadastre.name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list-group>
          </v-list>
        </v-list-group>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "CadastreSideMenu",
  props: {
    definitions: {
      type: Array,
      default: () => []
    },
    inEditMode: {
      type: Boolean,
      default: () => false
    },
    inSelectMode: {
      type: Boolean,
      default: () => false
    },
    combos: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    //category_select: [{text: 'Auftragsgruppen', value: "AUGR"}, {text: 'Kataster', value: "CADASTRE"}],
    category_select_value: 'CADASTRE',
    currentSelectionOrder: {
      definitionIndex: undefined,
      cadastreIndex: undefined,
      subDefinitionIndex: undefined,
      subCadastreIndex: undefined
    },
    currentSelection: undefined,
  }),
  computed: {
    category_select() {
      let res = [{text: 'Auftragsgruppen', value: "AUGR"}, {text: 'Kataster', value: "CADASTRE"}];
      for (let i = 0; i < this.combos.length; i++) {
        res.push({text: this.combos[i].name, value: this.combos[i].id})
      }
      //res.push({text: "Erstellen", value: "new"})
      return res
    }
  },
  methods: {
    changeSelection(value) {
      this.category_select_value = value;
      this.$emit('category-changed', this.category_select_value)
    },
    onItemClicked(event, currentId, definitionIndex, cadastreIndex, subDefinitionIndex, subCadastreIndex) {
      if (event.srcElement.className.includes('v-icon') || event.srcElement.className.includes('v-btn')) {
        return; // Ignore clicks on icons
      }
      // prevent the event from propagating to parent elements
      event.stopImmediatePropagation();
      event.stopPropagation();
      if (this.inEditMode) {
        this.$emit('no-select')
        return;
      }
      let lastSelection = {
        indices: [
          this.currentSelectionOrder.definitionIndex,
          this.currentSelectionOrder.cadastreIndex,
          this.currentSelectionOrder.subDefinitionIndex,
          this.currentSelectionOrder.subCadastreIndex
        ],
        selectionId: this.currentSelection
      };
      if (this.currentSelection === currentId) {
        this.currentSelectionOrder = {
          definitionIndex: undefined,
          cadastreIndex: undefined,
          subDefinitionIndex: undefined,
          subCadastreIndex: undefined
        };
        this.currentSelection = undefined;
      } else {
        this.currentSelection = currentId;
        this.currentSelectionOrder = {
          definitionIndex: definitionIndex,
          cadastreIndex: cadastreIndex,
          subDefinitionIndex: subDefinitionIndex,
          subCadastreIndex: subCadastreIndex
        };
      }
      let currentSelection = {
        indices: [
          this.currentSelectionOrder.definitionIndex,
          this.currentSelectionOrder.cadastreIndex,
          this.currentSelectionOrder.subDefinitionIndex,
          this.currentSelectionOrder.subCadastreIndex
        ],
        selectionId: this.currentSelection
      };
      this.$emit('selection-changed', {
        lastSelection: lastSelection,
        currentSelection: currentSelection
      });
    },
    setCurrentSelection(selectionId) {
      this.currentSelection = selectionId;
      this.$nextTick(() => {
        setTimeout(() => {
          let element = this.$refs[selectionId];
          if (element && element.length > 0) {
            element[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 500);
      });
    }
  }
}
</script>


<style scoped lang="scss">

.v-list-item-group .v-list-item--active {
  background-color: #63c2de;
}
::v-deep  .v-list-group__header {
  padding: 0 4px !important;
}

.cadastre-list {
  max-height: calc(100vh - 111px);
  min-height: calc(100vh - 111px);
  overflow-y: auto;
}

.select-mode {
  max-height: calc(100vh - 248px) !important;
  min-height: calc(100vh - 248px) !important;
}

::v-deep .v-list-group--no-action > .v-list-group__items > .v-list-item {
  padding-left: 18px !important;
}

::v-deep .v-list-item__action {
  margin: 6px 0;
}

::v-deep .v-list-item__content {
  padding: 6px 0;
}

::v-deep .v-list-item {
  min-height: 38px;
  transform: translate(0, 0);
  padding: 0 10px;
}

::v-deep .v-list-item__icon {
  margin: 8px 0 0px;
}

::v-deep .v-list {
  padding: 0px;
}

::v-deep .primary--text {
  color: rgba(0, 0, 0, 0.87) !important;
}

::v-deep .mdi-chevron-down::before {
  color: rgba(0, 0, 0, 0.54) !important;
}

::v-deep .mdi-menu-down::before {
  color: rgba(0, 0, 0, 0.54) !important;
}

::v-deep .v-list-group__header__prepend-icon {
  margin-top: 6px !important;
  margin-right: 6px !important;
  margin-left: 0px;
}

.expanded {
  margin-top: 6px !important;
  margin-right: 6px !important;
  margin-left: 5px;
}

::v-deep .v-list-item--active .expanded .v-icon {
  transform: rotate(-180deg);
}

.active-title {
  color: #3f51b5 !important;
}

::v-deep .active-background>.v-list-group__header {
  background-color: rgba(63, 81, 181, 0.07) !important;
}

::v-deep .active-background.v-list-item {
  background-color: rgba(63, 81, 181, 0.07) !important;
}

.hidden {
  visibility: hidden !important;
}

</style>
